module.exports = __webpack_public_path__ + "ptc_nakagawa_M2.3e49463d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_M2.jpg
// module id = 8rqW
// module chunks = 0